import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminRoute from '../AuthPages/AdminRoute';
import Admin from '../../components/AdminExcel/Admin';
import EmailUsers from './EmailUsers';
import LoginAdmin from './Login';
import AdminBlogs from './AdminBlogs';
import BlogEditor from './BlogEditor';
import AdminNewsletters from './AdminNewsletters';
import AdminChallengeRegistrations from './AdminChallengeRegistrations';

const AdminDashboard = React.lazy(() => import('./AdminDashboard'));

function AdminPages(props) {
  return (
    <div>
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route
            path="dashboard"
            element={
              <AdminRoute>
                <AdminDashboard {...props} />
              </AdminRoute>
            }
          />
          <Route
            path="email-users"
            element={
              <AdminRoute>
                <EmailUsers {...props} />
              </AdminRoute>
            }
          />
          <Route
            path="excel-upload"
            element={
              <AdminRoute>
                <Admin {...props}/>
              </AdminRoute>
            }
          />
          <Route
            path="blogs"
            element={
              <AdminRoute>
                <AdminBlogs {...props}/>
              </AdminRoute>
            }
          />
          <Route
            path="newsletters"
            element={
              <AdminRoute>
                <AdminNewsletters {...props}/>
              </AdminRoute>
            }
          />
          <Route
            path="challenge-registrations"
            element={
              <AdminRoute>
                <AdminChallengeRegistrations {...props}/>
              </AdminRoute>
            }
          />
          <Route
            index
            element={
              localStorage.getItem('admin_token') ? (
                <Navigate to="/admin/challenge-registrations" replace />
              ) : (
                <LoginAdmin {...props} />
              )
            }
          />
          <Route
            path="*"
            element={
              localStorage.getItem('admin_token') ? (
                <Navigate to="/admin/email-users" replace />
              ) : (
                <Navigate to="/admin" replace />
              )
            }
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default AdminPages;
